import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {sendAppraisalCertificate} from 'store/actions/user.action';
import {handleToast, isValidEmail} from 'utils/handler';
import successMessages from 'utils/successMessages';
import PopupWindow from 'views/components/Popup';

const EmailModal = ({closePopup, domain}): JSX.Element => {
  const {t} = useTranslation();
  const [showLoading, setShowLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [checkError, setCheckError] = useState(false);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setCheckError(true);
    if (email) {
      setShowLoading(true);
      sendAppraisalCertificate({domainName: domain, email: email, name: email.split('@')[0]})
        .then((emailResponse) => {
          if (emailResponse) {
            handleToast({message: successMessages.appraisalSent}, 'success');
            closePopup();
          } else setShowLoading(false);
        })
        .catch(() => setShowLoading(false));
    }
  };
  return (
    <PopupWindow onClose={closePopup} className="mw-45" header={"Appraisal certificate for " + domain} >
      <div className="model">
        <form onSubmit={submit} className="custom-form">
          <div>
            <div className="form-group">
              <input autoComplete="off" type="email" className={' form-control saw-input ' + ((checkError && isValidEmail(email)) || (checkError && email === '') ? 'is-invalid' : '')} name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('Enter your Email*')} />
              <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
            </div>
          </div>
          <div className="form-row justify-content-center">
            <button className="btn btn-grad" disabled={showLoading} onClick={submit}>
              Send
            </button>
          </div>
        </form>
      </div>
    </PopupWindow>
  );
};

export default EmailModal;
